import { combineReducers } from 'redux';

// Front
import Layout from './layout/reducer';

// Authentication
import Login from './auth/login/reducer';

// Tech support
import CustomerService from './customer-service/reducer';

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  CustomerService,
});

export default rootReducer;
